import { supabaseClient, useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchPublishedGuides } from '@data';

export const getGuidesQueryKey = () => ['guides'] as const;

export const useGuides = () => {
    const { data: user } = useUser();

    return useQuery({
        queryKey: getGuidesQueryKey(),
        queryFn: () => fetchPublishedGuides(supabaseClient),
        enabled: !!user?.id,
    });
};
